<template>
	<b-overlay :show="showoverlay" rounded="sm">
		<div>
			<div class="row no-margin">
				<div class="col-md-4">
					<h4 class="atlhr-dashboard-title mt-10">
						Employee Management
						<span>
							<a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a>
							/ Employee Management
						</span>
					</h4>
				</div>
				<div class="col-md-8 pr-0">
					<div v-if="employee_id > 0">
						<employee-previous-next :pageurl="this.$api_url">
						</employee-previous-next>
					</div>
				</div>
			</div> 
			<b-alert show dismissible fade v-if='successmsg'>
				{{successmsg}}
			</b-alert>
			<b-alert show dismissible fade v-if='warningmsg' variant='warning'>
				{{warningmsg}}
			</b-alert>
			<b-alert show dismissible fade v-if='dangermsg' variant='danger'>
				{{dangermsg}}
			</b-alert>
			<div class="clearfix row no-gutters employee-profile" v-if="employee_id > 0">
				<employee-public-info :pageurl="this.$api_url" :key="c_flg">
				</employee-public-info>
			</div>
			<div class="employee-tab" :class="{'new-employee-container' : employee_id == 0}">
				<b-tabs v-model="ewtabIndex" pills content-class="" nav-class="pr-2 m-2" nav-wrapper-class="col-md-9 card no-shadow custom-margin custom-tab-nav ml-auto pl-0">
					<template v-if="ce">
						<b-tab>
							<template active v-slot:title>
								Profile
							</template>
							<div class="clearfix">
								<div class="">
									<account-employees :pageurl="this.$api_url" :flg="1" v-on:childToParent="getAccountEmployees">
									</account-employees>
								</div>
							</div>
						</b-tab>
						<b-tab lazy v-if="employee_id > 0">
							<template active v-slot:title>
								Contracts
							</template>
							<div class="clearfix">
								<div class="">
									<contract-form :pageurl="this.$api_url" @event="contractChanged">
									</contract-form>
								</div>
							</div>
						</b-tab>
						<b-tab disabled v-else>
							<template v-slot:title>
								Contracts
							</template>
							<div class="clearfix">
								<div class="">
									&nbsp;
								</div>
							</div>
						</b-tab>
						<b-tab lazy v-if="employee_id > 0">
							<template active v-slot:title>
								Gratuity Fund
							</template>
							<div class="clearfix">
								<div class="">
									<gf-contributions :pageurl="this.$api_url">
									</gf-contributions>
								</div>
							</div>
						</b-tab>
                        <b-tab lazy v-if="employee_id > 0">
                            <template active v-slot:title>Gratuity Fund Slips</template>                
                            <div class="clearfix">
                                <div class="">                            
                                    <employeegfslips :pageurl="this.$api_url"></employeegfslips>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab disabled v-else>
                            <template  v-slot:title>Gratuity Fund Slips</template>                
                            <div class="clearfix">
                                <div class="">
                                    &nbsp;
                                </div>
                            </div>
                        </b-tab>
						<b-tab disabled v-else>
							<template v-slot:title>
								PfContributions
							</template>
							<div class="clearfix">
								<div class="">
									&nbsp;
								</div>
							</div>
						</b-tab>
						<b-tab lazy v-if="employee_id > 0">
							<template active v-slot:title>
								Migrated GF History
							</template>
							<div class="clearfix">
								<div class="">
									<employee-mgf-info :pageurl="this.$api_url" :flg="1">
									</employee-mgf-info>
								</div>
							</div>
						</b-tab>
						<b-tab disabled v-else>
							<template v-slot:title>
								Migrated GF History
							</template>
							<div class="clearfix">
								<div class="">
									&nbsp;
								</div>
							</div>
						</b-tab>
					</template>
				</b-tabs>
			</div>
			<b-modal id="bv-modal-employeesearch" size="lg" hide-footer title="Search Employees">
				<keep-alive>
					<search-employees>
					</search-employees>
				</keep-alive>
			</b-modal>
		</div>
	</b-overlay>
</template>
<script>
    
    
    //import AccountEmployees from './AccountEmployees';
    //import ContractForm from './ContractForm';
    //import EmployeeInvestmentInfo from './EmployeeInvestmentInfo';
    //import EmployeeAitInfo from './EmployeeAitInfo';
    //import SearchEmployees from './SearchEmployees';    
    //import PfContributions from './PfContributions'; 
    //import EmployeeRfcInfo from './EmployeeRfcInfo'; 
    //import EmployeeMphInfo from './EmployeeMphInfo';
    //import EmployeeMpfInfo from './EmployeeMpfInfo';
    
    

    

    
    export default{
        mounted() {
            this.setTabIndex();
            //this.showoverlay = false;  
            setTimeout(this.showContent , 3000);    
            
        },
        props: ['pageurl' , 'readonly'],
        components: {
            //AccountEmployees, ContractForm, EmployeeInvestmentInfo , EmployeeAitInfo , SearchEmployees, PfContributions , EmployeeRfcInfo , EmployeeMphInfo , EmployeeMpfInfo
        },
        data(){            
            
            return {
                showoverlay : true,
                cu:window.location.href,
                ce : false,
                pageUrl : this.$api_url,
                pgeUrl : this.$api_url,
                avatarsrc : null,
                employee_id : 0,
                company_id : 0,
                ewtabIndex : 0,
                employee_exists : 'employee-exists',
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                
                isHovered: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                c_flg: 0, // This variable is for reloading public info

            }
        },
        methods:{
            
            showContent: function()
            {
                this.showoverlay = false;
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;   
                    if(this.ce == false) this.ewtabIndex = 0;

                }.bind(this));
            }, 
            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            getEmployeeData: function(){
                if(!this.checkNet()) return false;
                
                this.c_flg += 1;
                //alert('hi');
                /*axios.get(this.$api_url+'/employee/publicinfo')
                    .then(function (response) {
                        
                        this.public_info = response.data;
                        this.company_id = this.public_info.company_id;
                        this.employee_id = this.public_info.employee_id;
                        
                        this.avatarsrc = this.$api_url+'/public/images/employee/'+ this.company_id + '/' + this.public_info.pic;

                    }.bind(this));*/
            },                        
            handleHover(hovered) {
                
                this.isHovered = hovered
            },
            getAccountEmployees (value) 
            {
                this.employee_id = value.employee_id;
                if(this.employee_id > 0)
                {
                    this.getEmployeeData();
                }                   

            },
            getContractForm (value) 
            {
                this.public_info.contract_expire = value.contract_expire;
            },
            contractChanged(value){
               if(value=='removed' || value=='added'){
                  this.c_flg += 1;
               }
            },
            setTabIndex:function(event)
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/getid')
                    .then(function (response) {

                        if(this.ce == false)
                        {
                            this.ewtabIndex = 0;
                            return;
                        }
                        
                        this.employee_id = response.data;
                        
                            let uri = window.location.href.split('?');
                            if (uri.length == 2)
                            {
                                let vars = uri[1].split('&');
                                let getVars = {};
                                let tmp = '';
                                vars.forEach(function(v){
                                    tmp = v.split('=');
                                    if(tmp.length == 2)
                                        getVars[tmp[0]] = tmp[1];
                                });
                                //console.log(getVars['#']);
                                if(getVars['#'])
                                    this.ewtabIndex = parseInt(getVars['#']);
                                
                            }                       
                                            

                    }.bind(this));                

            },
        },
        created: function(){
            //
            this.getAcl();
            //this.getEmployeeData();
            //this.setTabIndex();
        }

    }

</script>